import React from "react";
import PrincipalLogo from "../../../assets/images/principal.png";
import { text } from "../../../utils/styles/style";
import { Typography } from "@mui/material";
import NumberFormat from "react-number-format";
import moment from "moment";
import Button from "@mui/material/Button";

function FailedTrxSts(props) {
  const { classes, custData, paymentCategory, totalFee, canceledData } = props;

  const ActiveLink = ({ content, link = false }) => {
    return (
      <a
        onClick={e => {
          if (custData.customerChannelCode === "Mini Program" && window.my) {
            e.preventDefault();
            window.my.navigateTo({
              url:
                "/pages/link/link?url=" +
                encodeURIComponent("https://www.principal.com.my/en/contact-us")
            });
          }
        }}
        href={link}
        className="active-link"
        target={link ? "_blank" : "_self"}
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  };

  return (
    <>
      <div style={{ padding: "0 2rem", marginTop: 16 }}>
        <img
          src={PrincipalLogo}
          alt="Principal"
          style={{
            maxWidth: "40%",
            marginBottom: "16px",
            width: 124.7,
            height: 40
          }}
        />

        <Typography
          //style={{  margin: 24px 0 16px; }}
          sx={classes.titleFailed}
        >
          Cash In cancelled
        </Typography>
        <p style={{ margin: "16px 0 23px" }}>
          Sorry, we were unable to process the Cash In. Please try again or
          contact our
          <ActiveLink
            link="https://www.principal.com.my/en/contact-us"
            content=" customer support"
          />
        </p>
      </div>
      <div style={{ padding: "0 2rem" }}>
        <div className="doted space-between" style={{ margin: "20px 0" }} />
        <div className="paymentStatus-container">
          <div className="deposit-via-info">
            <p className="status-label">Cash In amount</p>
            <p className="">
              {"RM"}{" "}
              <NumberFormat
                value={parseFloat(custData.amount).toFixed(2)}
                thousandSeparator={true}
                displayType="text"
                decimalSeparator="."
              />
            </p>
          </div>
          <div className="deposit-via-info">
            <p>Administrative fee</p>
            <p className="">
              {"RM"} {parseFloat(custData.fee).toFixed(2)}
            </p>
          </div>
          <div className="deposit-via-info">
            <p className="status-label">Cash In via</p>
            <p className="">{paymentCategory.description || "No Data"}</p>
          </div>
          <div className="deposit-via-info">
            <p className="status-label">Date</p>

            <p className="">
              {moment(canceledData.time || new Date())
                .utcOffset(8)
                .format("DD MMM YYYY")}
            </p>
          </div>
          <div className="deposit-via-info">
            <p className="status-label">Time</p>
            <p className="">
              {moment(canceledData.time || new Date())
                .utcOffset(8)
                .format("hh:mm:ss A")}
            </p>
          </div>
          <div className="deposit-via-info">
            <p>Transaction no</p>
            <p className="ref-no">{custData.trxRefNo || "No Data"}</p>
          </div>

          <div className="deposit-via-info">
            <p className="bolded total" style={{ color: text.color.blue }}>
              Total :
            </p>
            <p style={{ color: text.color.blue }} className="bolded total">
              {"RM"}{" "}
              <NumberFormat
                value={totalFee.toFixed(2)}
                thousandSeparator={true}
                displayType="text"
                decimalSeparator="."
                className="bolded total"
              />
            </p>
          </div>
        </div>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0 20px",
            marginTop: 24
          }}
          className="SubmitButton"
        >
          <Button
            onClick={() => {
              window.location.replace(paymentCategory.channelUrl);
              // props.history.goBack();
              // postToChannel(paymentStatus);
              //  console.log(postToChannel);
              window.dataLayer.push({
                event: "click_tag",
                action: "Click",
                category: "Done",
                label: "Cash In Cancel"
              });
            }}
            variant="contained"
            color="secondary"
            className="next-button"
            fullWidth
            style={{ marginBottom: 24 }}
          >
            Done
          </Button>
        </div>
      </div>
    </>
  );
}

export default FailedTrxSts;
